<template>
    <a v-if="shouldShow()" :href="href()"><slot></slot></a>
</template>

<script setup lang="ts">
    import {usePrismicFieldHelpers, useTypeGuards} from '@navbar-unlogged/composables';
    import type {KeyTextField, LinkField} from '@prismicio/types';
    import {useLinkHelper} from '#imports';

    const {isLink} = usePrismicFieldHelpers();
    const {isFilledKeyText} = useTypeGuards();
    const {getLink} = useLinkHelper();

    const props = defineProps<{
        field: LinkField | KeyTextField;
    }>();

    function shouldShow(): boolean {
        return isFilledKeyText(props.field) || isLink('_', props.field);
    }

    function href(): string {
        return getLink(props.field)?.url ?? '';
    }
</script>
